export default __webpack_public_path__ + "static/3-contrast-86834428487f97e6c1049ac729b8f6d2.png";